angular.module('impactx.approval').controller('DelegationUserController', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'selectionData',
    'entryPoint',
    DelegationUserController]);

function DelegationUserController($scope, $mdDialog, dataGen, selectionData, entryPoint) {
    dataGen.post($scope, selectionData, entryPoint).then(function() {
    });

    $scope.hide = function() {
        $mdDialog.hide();
    };
    $scope.cancel = function() {
        $mdDialog.cancel();
    };
    $scope.answer = function(answer) {
        $mdDialog.hide(answer);
    };
}